module.exports = __webpack_public_path__ + "assets/img/8.cc8f659d.jpg";